export interface Options {
  host: string
  client?: string
}

export const defaultOptions: Options = {
  host: 'api.geocode.earth'
}
